import React from 'react';

import L2Page from '../../../templates/l2-page';

import heroDark from './_assets/hero.dark.png';
import heroLight from './_assets/hero.light.png';
import Content from './_index.mdx';

export default () => {
	return (
		<L2Page
			categorySlug="content-design"
			title="Content design"
			description="Learn about UI content standards, voice and tone principles, and design assets."
			entries={[]}
			image={{
				light: heroLight,
				dark: heroDark,
			}}
		>
			<Content />
		</L2Page>
	);
};
